import { render, staticRenderFns } from "./Omatome.vue?vue&type=template&id=1c14b74c&scoped=true&"
import script from "./Omatome.vue?vue&type=script&lang=js&"
export * from "./Omatome.vue?vue&type=script&lang=js&"
import style0 from "./Omatome.vue?vue&type=style&index=0&id=1c14b74c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c14b74c",
  null
  
)

export default component.exports